import axios from 'axios';
import { useAuth } from './authContext';
import { resetUserInfo } from './userInfo';

const useSignOut = () => {
  const { removeSession } = useAuth();

  const signOut = async () => {
    try {
      await axios.post('/api/signout');
    } catch (err) {
      console.warn('Sign out API call failed: ', err);
    }
    // removeSession(true) handles SyncEngine shutdown + local data cleanup in the modernized authContext.
    removeSession(true);
    resetUserInfo();
  };

  return signOut;
};

export default useSignOut;
